<template>
  <div class="home">
<!--    <h1 class="text-[#1f2c38] text-3xl text-center font-semibold mb-6">-->
<!--      Food Recipes-->
<!--    </h1>-->
    <div class="flex space-x-2 justify-center">
      <h2 class=" text-4xl font-semibold mb-14 leading-tight text-gray-800">
        Just Food
        <span class="inline-block py-1.5 px-2.5 leading-none text-center whitespace-nowrap align-baseline font-bold bg-green-600 text-white rounded">Recipe</span>
      </h2>
    </div>
    <RecipesForm/>
    <RecipesList/>
  </div>
</template>

<script>

import RecipesList from "@/components/RecipesList";
import RecipesForm from "@/components/RecipesForm";
export default {
  name: 'HomeView',
  components: {RecipesForm, RecipesList},
}
</script>
